/**
 * Frontend Environment Configuration
 * Centralized configuration for frontend
 */

const config = {
    // API Configuration
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL || 'https://codification-gateway-6nubtp2n.uc.gateway.dev',
    apiKey: process.env.REACT_APP_API_KEY,

    // API Endpoints
    endpoints: {
        chat: {
            generate: '/v1/chat/generate'
        },
        memory: {
            history: '/v1/memory/history',
            similar: '/v1/memory/similar',
            clean: '/v1/memory/clean'
        }
    },

    // Google Analytics
    googleAnalytics: {
        measurementId: process.env.REACT_APP_GA_MEASUREMENT_ID || 'G-RF95CX1PDE'
    },

    // Feature Flags
    features: {
        enableMemory: process.env.REACT_APP_ENABLE_MEMORY !== 'false',
        enableCache: process.env.REACT_APP_ENABLE_CACHE !== 'false',
        enableAnalytics: process.env.REACT_APP_ENABLE_ANALYTICS !== 'false'
    }
};

export default config;
